import React from 'react';

interface ErrorBoundaryProps extends React.PropsWithChildren {
  component: React.ComponentType<React.PropsWithChildren>;
}

interface ErrorBoundaryState {
  error: Error | null;
  hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { error, hasError: true };
  }

  render() {
    if (this.state.hasError) {
      const Component = this.props.component;

      return <Component>{import.meta.env.DEV ? this.state.error?.message : undefined}</Component>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
